import { getP } from 'redux-polyglot'
import { loadChannel } from '../actions/channels'
import api from '../libs/api'

/**
 * Actions for dismissing an error
 */
export const DISMISS_ERROR = 'DVR/DISMISS_ERROR'

export const dismissError = () => ({
  type: DISMISS_ERROR
})

/**
 * Actions for fetching a specific video details from API
 */
export const FETCH_VIDEO_REQUEST = 'VIDEO/FETCH/REQUEST'
export const FETCH_VIDEO_SUCCESS = 'VIDEO/FETCH/SUCCESS'
export const FETCH_VIDEO_FAILURE = 'VIDEO/FETCH/FAILURE'
export const FETCH_VIDEO_WARNING = 'VIDEO/FETCH/WARNING'

const fetchVideoRequest = id => ({
  type: FETCH_VIDEO_REQUEST,
  payload: {
    id: id
  }
})

const fetchVideoSuccess = (payload) => ({
  type: FETCH_VIDEO_SUCCESS,
  payload
})

const fetchVideoFailure = (id, error) => ({
  type: FETCH_VIDEO_FAILURE,
  payload: error instanceof Error ? error : new Error(error),
  meta: {
    id: id
  },
  error: true
})

const fetchVideoWarning = (id, error) => ({
  type: FETCH_VIDEO_WARNING,
  payload: error instanceof Error ? error : new Error(error),
  meta: {
    id: id
  },
  error: true
})

const sanitizeVideo = (rawVideo, t) => {

  const video = {
    id: rawVideo.id,
    name: rawVideo.name,
    desc: rawVideo.description,
    img: rawVideo.img.large,
    created: rawVideo.created,
    isPremium: !!rawVideo.is_premium,
    duration: parseFloat(rawVideo.duration),
    lastUpdated: Date.now()
  }

  if (rawVideo.sources && rawVideo.sources.hls) {
    video.playbackUrl = rawVideo.sources.hls
  }
  if (rawVideo.trick_play_url) {
    video.trickPlayUrl = rawVideo.trick_play_url
  }

  if (rawVideo.channel) {
    video.channel = {
      id: rawVideo.channel.id,
      name: rawVideo.channel.name,
      img: rawVideo.channel.img.small
    }
  }

  try {
    video.currentTime = +global.localStorage.getItem(`video-curr-time-${video.id}`)
  } catch (e) {
    video.currentTime = 0
  }

  if (rawVideo.is_premium && !rawVideo.has_access) {
    video.hasError = true
    video.errorMessage = t("tv_video_library.error_video_premium", { _: "This video is not available on the current subscription plan" })  
    if (rawVideo.show_id > 0) {
      video.paywall = true
      video.channelId = parseInt(rawVideo.show_id, 10)
    }
  }

  if (rawVideo.ad_tag_url) {
    video.adTagUrl = rawVideo.ad_tag_url
  }

  if (rawVideo.closed_captions) {
    video.closedCaptions = rawVideo.closed_captions.map((closedCaption) => ({
      language: closedCaption.short_name.toLowerCase(),
      label: closedCaption.name,
      src: closedCaption.url
    }))
  }

  return video
}

export const loadVideo = (id, skipErrors = false, width = 1280, height = 720, appType='tv-v2', deviceMake = '', appBundle = '') => (dispatch, getState) => {
  if (!skipErrors) {
    dispatch(fetchVideoRequest(id))
  }
  return api.getVideo(id, width, height, appType, deviceMake, appBundle)
    .then(res => res.json())
    .then(
      response => {
        if (response.status === 200) {
          if (response.video.is_premium && !response.video.has_access && response.video.show_id) {
            const channelId = parseInt(response.video.show_id, 10)
            if (channelId > 0) {
              return dispatch(loadChannel(channelId))
                .then(() => dispatch(fetchVideoSuccess(sanitizeVideo(response.video, getP(getState()).t))))
            } else {
              return dispatch(fetchVideoSuccess(sanitizeVideo(response.video, getP(getState()).t)))
            }
          } else {
            return dispatch(fetchVideoSuccess(sanitizeVideo(response.video, getP(getState()).t)))
          }
        } else {
          return dispatch(fetchVideoFailure(id, response.reason))
        }
      },
      (err) => {
        if (skipErrors) {
          return dispatch(fetchVideoWarning(id, err))
        } else {
          return dispatch(fetchVideoFailure(id, getP(getState()).t("tv_video_library.error_retrieving_video_details", { _: "An error occurred while retrieving video details" })))
        }
      }
    )
}

/**
 * Actions related to video playback
 */

export const UPDATE_CURRENT_TIME = 'VIDEO/PLAYBACK/UPDATE_CURRENT_TIME'

export const updateCurrentTime = (videoId, currentTime) => {
  try {
    global.localStorage.setItem(`video-curr-time-${videoId}`, currentTime)
  } catch (e) {
    // nothing to do
  }
  return {
    type: UPDATE_CURRENT_TIME,
    payload: {
      id: videoId,
      currentTime
    }
  }
}
